import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import crudApi from "@serie3/common/api/crudApi";
import MediaplannerGroupEndpoints from "@serie3/mymediaplanner/Modules/Groups/endpoints";
import ApprovalScheduleList from "../../Approvals/ApprovalScheduleList";

/**
 * Every schedule in this group that publishes on a member's account. The
 * member a row is planned for decides in the modal; everyone else sees the
 * state. Images load through the member-gated group routes.
 */
const GroupApprovalsTab = ({ group }) => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!group?.id) return;
    setLoading(true);
    crudApi
      .justGet(MediaplannerGroupEndpoints.endpoints.approvals + group.id)
      .then((r) => { if (r.ok) setSchedules(r.data?.schedules ?? []); })
      .finally(() => setLoading(false));
  }, [group?.id]);

  const onDecided = (updated) => {
    setSchedules((prev) => prev.map((s) => (s.id === updated.id ? { ...s, ...updated } : s)));
  };

  const loadFiles = async (schedule) => {
    if (!schedule?.post?.id || !group?.id) return null;
    const r = await crudApi.getAll(MediaplannerGroupEndpoints.endpoints.postFiles + group.id + "/" + schedule.post.id);
    return {
      files: r?.ok && Array.isArray(r.data) ? r.data : [],
      binaryEndpoint: MediaplannerGroupEndpoints.endpoints.getImageBinary + group.id + "/",
    };
  };

  return (
    <Card>
      <Card.Body>
        {loading ? (
          <div className="skeleton" style={{ height: 80, borderRadius: 10 }} />
        ) : (
          <ApprovalScheduleList schedules={schedules} onDecided={onDecided} loadFiles={loadFiles} />
        )}
      </Card.Body>
    </Card>
  );
};

export default GroupApprovalsTab;
